import axios from 'axios';
import { Fragment, useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import MemoDestinationsDDL from '../../components/memoDestinationsDDL';
import { ApiKey, BaseUrl, processNum, valdiatePage } from '../../global';
import { setLoading } from '../../redux/appSlice';
import { getLocations } from '../../services/userservice';

const Tariff = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { userInfo, loading, accounts, destinations, services } = useSelector(state => state.appData);

    const initd = {
        account: '',
        origin: '',
        destination: '',
        weight: '',
        serviceType: ''
    }

    const destRef = useRef(null);
    const [data, setData] = useState(initd);
    const [branches, setBranches] = useState([]);
    const [tariff, setTariff] = useState(null);

    useEffect(() => {
        if (!valdiatePage('/tariff')) {

            history.push('/login');
        }
    }, []);

    const getAccountBranches = async (account) => {
        try {
            const rs = await axios.get(BaseUrl + 'api/Booking/GetAccountBranches' + `?account=${account}`, {
                headers: {
                    key: ApiKey,
                }
            });
            return rs.data;
        } catch (e) {
            console.log(e);
            return { ok: false, msg: e }
        }
    }

    const getTariff = async (d) => {
        try {

            const rs = await axios.post(BaseUrl + 'api/Booking/GetTariff', d, {
                headers: {
                    key: ApiKey,
                }
            });
            return rs.data;
        } catch (e) {
            console.log(e);
            return { ok: false, msg: e }
        }
    }

    const onGetTariff = async () => {

        if (!data.account) {
            alert('Select Account');
            setTariff([]);
            return;
        }

        if (!data.origin) {
            alert('Select Origin');
            setTariff([]);
            return;
        }

        if (!data.destination) {
            alert('Select Destination');
            setTariff([]);
            return;
        }

        if (!data.serviceType) {
            alert('Select Service Type');
            setTariff([]);
            return;
        }

        if (!data.weight || +data.weight <= 0) {
            alert('Enter Weight');
            setTariff([]);
            return;
        }

        dispatch(setLoading({ data: true }));
        const rs = await getTariff(data);
        dispatch(setLoading({ data: false }));

        if (rs.ok)
            setTariff(rs.data);
        else {
            alert(rs.msg);
            setTariff([]);
        }
    }


    useEffect(() => {
        if (data.account)
            getAccountBranches(data.account).then(rs => {
                if (rs && rs.ok)
                    setBranches(rs.data);
                else {
                    setBranches([]);
                }
            })
    }, [data.account])

    const updateData = (key, val) => setData(prev => ({ ...prev, [key]: val }))

    return userInfo &&
        <section className="section">
            <div className="section-header">
                <h1>Tariff</h1>
            </div>
            <div className="card" style={{ padding: 10 }}>
                <div className="row">
                    <div className='col-lg col-sm'>
                        <label>Account</label>
                        <select className='form-select' value={data.account} onChange={e => updateData('account', e.target.value)}>
                            <option value=''>Select Account</option>
                            {
                                accounts.map((x, index) => <option key={index} value={x}>{x}</option>)
                            }
                        </select>
                    </div>
                    <div className='col-lg col-sm'>
                        <label>Origin</label>
                        <select className='form-select' value={data.origin} onChange={e => updateData('origin', e.target.value)}>
                            <option value=''>Select Origin</option>
                            {
                                branches.map((x, index) => <option key={index} value={x.value}>{x.text}</option>)
                            }
                        </select>
                    </div>
                    <div className='col-lg col-sm'>
                        <label>Destination</label>
                        <MemoDestinationsDDL destRef={destRef} label="Destination" destinations={destinations} onChange={(e) => {
                            const val = e.target.value;
                            updateData('destination', val);
                        }} />
                    </div>
                    <div className='col-lg col-sm'>
                        <label>Service Type</label>
                        <select className='form-select' value={data.serviceType} onChange={e => updateData('serviceType', e.target.value)}>
                            <option value=''>Select Service Type</option>
                            {
                                services.map((x, index) => <option key={index} value={x}>{x}</option>)
                            }
                        </select>
                    </div>
                    <div className='col-lg col-sm'>
                        <label>Weight</label>
                        <input type='text' className='form-control' onInput={processNum} value={data.weight} onChange={e => updateData('weight', e.target.value)} />
                    </div>
                </div>
                <div className='row mt-2'>
                    <div className='col' style={{ textAlign: 'right' }}>
                        <button type='button' className='btn btn-primary' onClick={onGetTariff}>Submit</button>
                    </div>
                </div>
                {
                    tariff && <div className='row mt-2'>
                        <div className='col'>
                            <table className='table table-bordered'>
                                <thead>
                                    <tr>
                                        <th>Amount</th>
                                        <th>GST</th>
                                        <th>Fuel</th>
                                        <th>Fuel GST</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{tariff.amount}</td>
                                        <td>{tariff.gst}</td>
                                        <td>{tariff.fuel}</td>
                                        <td>{tariff.fuelgst}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                }

            </div>
        </section>
}

export default Tariff;